// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"134":"b5dcb3349f39edb8","163":"a43220fe7e20ebc5","164":"2435b124a41df612","488":"78955824926cd0b3","813":"cb4b58a4b125e2d9"}[chunkId] + ".js";
};